export default __webpack_public_path__ + "static/media/G0535.34I-29298_-16973_0.1664453340000.56df4307.jpg";